import React, {Component} from 'react';
import {Breadcrumb, Button, Grid} from 'semantic-ui-react';
import {Helmet} from "react-helmet";
import CustomDivider from "../../components/extras/CustomDivider";
import ChangelogData from "../../data/ChangelogData";
import Loading from "../../components/extras/Loading";
import ChangelogCard from "../../components/updates/ChangelogCard";

class ChangeLogs extends Component {
    constructor(){
        super();
        this.state = {
            data: {
                results: []
            },
            loading: true,
            load_more: true,
        }
    }

    componentWillMount(){
        this.loadData('',1);
        ChangelogData.readAll();
    }

    loadData = (search, page) => {
        this.setState({load_more:true});
        ChangelogData.list(search, page).then(data=>{
            let last_results = this.state.data.results.slice();
            data.results = last_results.concat(data.results);
            this.setState({loading:false, data, load_more:false})
        }).catch((error)=>{
            console.log(error);
        });
    };

    changeLogs = () => {
        return this.state.data.results.map(changelog => {
            return <ChangelogCard {...changelog} key={changelog.id}/>;
        });
    };

    render() {
        return (
            <div>
                <Helmet>
                    <title>Actualizaciones - Bisttros</title>
                </Helmet>
                <Breadcrumb>
                    <Breadcrumb.Section active>Actualizaciones</Breadcrumb.Section>
                </Breadcrumb>
                <CustomDivider/>
                {!this.state.loading ?<Grid>{this.changeLogs()}</Grid>:<Loading/>}
                {this.state.data.next ?<Grid>
                    <Grid.Row columns={2} centered>
                        <Grid.Column mobile={16} tablet={12} computer={10} largeScreen={10} widescreen={10}>
                            <Button
                                fluid
                                onClick={() => this.loadData('', this.state.data.number+1)}
                                loading={this.state.load_more}
                                disabled={this.state.load_more}
                            >
                                Mostrar más
                            </Button>
                        </Grid.Column>
                    </Grid.Row>
                </Grid>:null}
            </div>
        );
    }
}
export default ChangeLogs;



// WEBPACK FOOTER //
// ./src/containers/home/ChangeLogs.js